import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullBranding from "../fragments/fullBranding"

const query = gql`
  query Branding($businessId: ID!, $teamId: ID, $userId: ID) {
    branding(businessId: $businessId, teamId: $teamId, userId: $userId) {
      ...fullBranding
    }
  }
  ${fullBranding}
`

export const brandingKey = getQueryNames(query)[0]

export default query
